<template>
	<div>
		<component
			:is="theme"
			:countDays="countDays"
			:countHours="countHours"
			:countMinutes="countMinutes"
			:countSeconds="countSeconds"
			:options="options"
			:previewDevice="previewDevice"
			:initialValue="initialDate"
		/>
	</div>
</template>
<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// eslint-disable-next-line import/no-unresolved
// import duration from 'dayjs/plugin/duration';
import 'dayjs/locale/id';

import CountdownDigital from '@/components/funnels/pagebuilder/parts/countdown/themes/Digital.vue';
import CountdownCircle from '@/components/funnels/pagebuilder/parts/countdown/themes/Circle.vue';
import {
// getRgbaColor,
} from '@/lib/helper';

// set cookie oo_timer_${page_id} = current time_stamp

dayjs.extend(utc);

export default {
	props: {
		options: {
			type: Object,
		},
		previewDevice: String,
	},
	components: {
		CountdownDigital,
		CountdownCircle,
	},
	data() {
		return {
			countDays: 0,
			countHours: 0,
			countMinutes: 0,
			countSeconds: 0,
			deadlineInfo: '',
			initialDate: 0,
		};
	},
	computed: {
		theme() {
			let theme = 'CountdownDigital';
			if (this.options && this.options.theme === 'circle') {
				theme = 'CountdownCircle';
			}
			return theme;
		},
	},
	created() {
		this.setCountDown();
	},
	methods: {
		/**
		 * Set Countdown
		 *
		 * @param {string} date
		 * @param {number} duration Duration (minutes)
		 */
		setCountDown() {
			const durationType = this.options.durationType;
			const date = this.options.date;
			// const day = this.options.day;
			const hours = this.options.hours;
			const minutes = this.options.minutes;
			let converDeadlineDate = new Date().getTime();

			if (durationType === 'duration') {
				const hoursToSecond = parseInt(hours) * 60 * 60;
				const minutesToSecond = parseInt(minutes) * 60;
				const duration = hoursToSecond + minutesToSecond + 60;
				converDeadlineDate = new Date().getTime() + duration * 1000;
			} else if (durationType === 'date') {
				const dateValue = `${date} ${hours}:${minutes}:0`;
				let formattedDate = dayjs(dateValue).format('YYYY-MM-DD HH:mm:ss');
				formattedDate = dayjs(formattedDate).locale('id');
				converDeadlineDate = new Date(formattedDate).getTime();
			}

			const deadline = converDeadlineDate;
			this.initialDate = deadline - new Date().getTime();

			// count interval
			const interval = setInterval(() => {
				const now = new Date().getTime();
				const distance = deadline - now;
				const _second = 1000;
				const _minute = _second * 60;
				const _hour = _minute * 60;
				const _day = _hour * 24;

				const days = Math.floor(distance / _day);
				const hours = Math.floor((distance % _day) / _hour);
				const minutes = Math.floor((distance % _hour) / _minute);
				const seconds = Math.floor((distance % _minute) / _second);

				if (durationType === 'date') {
					this.countDays = days;
				}

				this.countHours = hours;
				this.countMinutes = minutes;
				this.countSeconds = seconds;

				if (distance < 0) {
					clearInterval(interval);
					this.countHours = 0;
					this.countMinutes = 0;
					this.countSeconds = 0;
				}
			}, 10);
		},
	},
};
</script>
